import Login from "../views/Login.vue";
import Welcome from "../views/Welcome.vue";

const routes = [{
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      isShowHeader: false,
      isShowLeftSider: false,
      name: "登陆页"
    }
  },
  {
    path: "/home",
    name: "Welcome",
    component: Welcome,
    meta: {
      isShowHeader: false,
      isShowLeftSider: true,
      name: "主页"
    }
  },
  // config
  {
    path: "/manager/list",
    name: "managerList",
    component: () =>
      import(
        /* webpackChunkName: "manager-list" */
        "@/views/config/manager/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "管理员列表"
    }
  },
  {
    path: "/manager/create",
    name: "managerCreate",
    component: () =>
      import(
        /* webpackChunkName: "manager-create" */
        "@/views/config/manager/create.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "创建管理员"
    }
  },
  {
    path: "/manager/edit/:id",
    name: "managerEdit",
    component: () =>
      import(
        /* webpackChunkName: "manager-create" */
        "@/views/config/manager/edit.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "编辑管理员"
    }
  },
  {
    path: "/role/list",
    name: "roleList",
    component: () =>
      import(
        /* webpackChunkName: "role-list" */
        "@/views/config/role/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "角色管理"
    }
  },
  {
    path: "/role/create",
    name: "roleCreate",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/config/role/create.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "创建角色"
    }
  },
  {
    path: "/role/edit/:id",
    name: "roleEdit",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/config/role/edit.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "编辑角色"
    }
  },
  {
    path: "/param/list",
    name: "param",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/config/param/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "基本参数"
    }
  },
  {
    path: "/systemDiary/list",
    name: "systemDiary",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/config/systemDiary/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "系统日志"
    }
  },
  {
    path: "/seekLamp/list",
    name: "seekLamp",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/seekLamp/list.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowLeftSider: false,
      name: "寻灯",
    }
  },
  {
    path: "/seekLamp/detail/",
    name: "seekLampDetail",
    component: () =>
      import(
        "@/views/workbench/seekLamp/detail.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowLeftSider: false,
      name: "寻灯详情页",
    }
  },
  {
    path: "/installLamp/list",
    name: "installLamp",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "安灯作业"
    }
  },
  {
    path: "/installLamp/seat",
    name: "seat",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/seat.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "安灯作业"
    }
  },
  {
    path: "/installLamp/randomStepOne",
    name: "randomStepOne",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/randomStepOne.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "随机安灯"
    }
  },
  {
    path: "/installLamp/optionalStepOne",
    name: "optionalStepOne",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/optionalStepOne.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "自选灯位安灯"
    }
  },
  {
    path: "/installLamp/optionalStepTwo/:length",
    name: "optionalStepTwo",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/optionalStepTwo.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "自选灯位安灯"
    }
  },
  {
    path: "/installLamp/optionalStepThree/:length",
    name: "optionalStepThree",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/optionalStepThree.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "自选灯位安灯"
    }
  },
  {
    path: "/installLamp/optionalStepFour",
    name: "optionalStepFour",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/optionalStepFour.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "自选灯位安灯"
    }
  },
  {
    path: "/installLamp/randomStepTwo/:length",
    name: "randomStepTwo",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/randomStepTwo.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "随机安灯"
    }
  },
  {
    path: "/installLamp/randomStepThree/:length",
    name: "randomStepThree",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/randomStepThree.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "随机安灯"
    }
  },
  {
    path: "/installLamp/randomStepFour",
    name: "randomStepFour",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/installLamp/randomStepFour.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "随机安灯"
    }
  },

  {
    path: "/pilgrimsManage/list",
    name: "pilgrimsManage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/pilgrimsManage/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "香客信息管理"
    }
  },
  {
    path: "/pilgrimsManage/detail/:id",
    name: "pilgrimsDetail",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/pilgrimsManage/detail.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "香客详情"
    }
  },
  {
    path: "/pilgrimsManage/create/:id",
    name: "pilgrimsCreate",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/pilgrimsManage/create.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "修改香客信息"
    }
  },

  {
    path: "/lampHoleder/lampHolder",
    name: "pilgrimsManage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/lampHoleder/lampHolder.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯柱信息管理"
    }
  },
  // {
  //   path: "/pilgrimsManage/detail/:id",
  //   name: "pilgrimsDetail",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "role-create" */ "@/views/workbench/pilgrimsManage/detail.vue"
  //       ),
  //   meta: {
  //     isShowHeader: true,
  //     isShowLeftSider: true,
  //     name: "香客详情"
  //   }
  // },
  {
    path: "/lampHoleder/create/:id",
    name: "lampHolederCreate",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/lampHoleder/create.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "修改灯柱信息"
    }
  },

  {
    path: "/deliverData/list",
    name: "deliverData",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/deliverData/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "传送资料"
    }
  }, {
    path: "/deliverData/detail/:id",
    name: "deliverDataDetail",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/workbench/deliverData/detail.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "香客详情"
    }
  },

  {
    path: "/templeManage/list",
    name: "templeManage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/temple/templeManage/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "寺庙信息管理"
    }
  },
  {
    path: "/lampHolderManage/list",
    name: "lampHolderManage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderManage/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯座设备管理"
    }
  },
  {
    path: "/lampHolderManage/detail/:id",
    name: "lampHolderManageDetail",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderManage/detail.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯座设备管理"
    }
  },
  {
    path: "/lampHolderManage/create/:id",
    name: "lampHolderManageCreate",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderManage/create.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯座设备管理"
    }
  },
  {
    path: "/lampTypeCount/list",
    name: "lampTypeCount",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampTypeCount/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯种统计"
    }
  },
  {
    path: "/lampTypeManage/list",
    name: "lampTypeManage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampTypeManage/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯种管理"
    }
  },
  {
    path: "/lampHolderinformation/list",
    name: "lampHolderinformation",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderinformation/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯座信息管理"
    }
  },
  {
    path: "/lampHolderinformation/editLampholderinformation/:id",
    name: "editLampholderinformation",
    component: () =>
      import(
        "@/views/lampHolder/lampHolderinformation/editLampholderinformation"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "编辑灯座信息",
    }
  },
  {
    path: "/lampHolderinformation/checkLampholder",
    name: "checkLampholder",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderinformation/checkLampholder.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯座详情"
    }
  },
  {
    path: "/lampHolderinformation/lamppostinformation",
    name: "lamppostinformation",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderinformation/lamppostinformation.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯柱信息"
    }
  },
  {
    path: "/lampHolderinformation/createLampholderstepA",
    name: "lampHolderinformation",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderinformation/createLampholderstepA.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "新增灯座"
    }
  },
  {
    path: "/lampHolderinformation/lampConfiginformation",
    name: "lampConfiginformation",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderinformation/createLampholderStepB/lampConfiginformation.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯柱配置信息"
    }
  },
  {
    path: "/lampHolderinformation/horizonConfig",
    name: "horizonConfig",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampHolderinformation/createLampholderStepB/horizonConfig.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "配置层位"
    }
  },
  {
    path: "/lamppostInformation/list",
    name: "lamppostInformation",
    component: () =>
      import(
        "@/views/lampHolder/lamppostInformation/list.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯柱信息管理'
    }
  },
  {
    path: "/lamppostInformation/lamppostMaintenance",
    name: "lamppostMaintenance",
    component: () =>
      import(
        "@/views/lampHolder/lamppostInformation/lamppostMaintenance.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯柱检修'
    }
  },
  {
    path: "/lamppostInformation/sendConfiginformation",
    name: "sendConfiginformation",
    component: () =>
      import(
        "@/views/lampHolder/lamppostInformation/sendConfiginformation.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '发送配置信息'
    }
  },
  {
    path: "/lamppostDatabase/list",
    name: "lamppostDatabase",
    component: () =>
      import(
        "@/views/lampHolder/lamppostDatabase/list.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯柱资料库'
    }
  },
  {
    path: "/lampHoldercontrol/lampControl",
    name: "lampControl",
    component: () =>
      import(
        "@/views/lampHolder//lampHoldercontrol/lampControl.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_灯控制'
    }
  },
  {
    path: "/lampHoldercontrol/lookLamp",
    name: "lookLamp",
    component: () =>
      import(
        "@/views/lampHolder//lampHoldercontrol/lookLamp.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_寻灯'
    }
  },
  {
    path: "/lampHoldercontrol/clearLamp",
    name: "clearLamp",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/clearLamp.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_清灯'
    }
  },
  {
    path: "/lampHoldercontrol/clearTemplename",
    name: "clearTemplename",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/clearTemplename.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_清庙名'
    }
  },
  {
    path: "/lampHoldercontrol/sendTemplename",
    name: "sendTemplename",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/sendTemplename.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_传庙名'
    }
  },
  {
    path: "/lampHoldercontrol/clearName",
    name: "clearName",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/clearName.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_清人名'
    }
  },
  {
    path: "/lampHoldercontrol/sendName",
    name: "sendName",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/sendName.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_传人名'
    }
  },
  {
    path: "/lampHoldercontrol/LCD_LED",
    name: "LCD_LED",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/LCD_LED.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_LCD/LED'
    }
  },
  {
    path: "/lampHoldercontrol/changeMode",
    name: "changeMode",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/changeMode.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_模式变换'
    }
  },
  {
    path: "/lampHoldercontrol/systemInitialization",
    name: "systemInitialization",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/systemInitialization.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_系统初始化'
    }
  },
  {
    path: "/lampHoldercontrol/singMachine",
    name: "singMachine",
    component: () =>
      import(
        "@/views/lampHolder/lampHoldercontrol/singMachine.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯座控制_诵经机'
    }
  },
  {
    path: "/lamppositionManagement/list",
    name: "lamppositionManagement",
    component: () =>
      import(
        "@/views/lampHolder/lamppositionManagement/list.vue"
      ),
    meta: {
      isShowLeftSider: true,
      isShowHeader: true,
      name: '灯位管理'
    }
  },
  {
    path: "/lampTypeManage/detail/:id",
    name: "lampTypeManageDetail",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/lampHolder/lampTypeManage/detail.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "灯种详情"
    }
  },
  {
    path: "/imageDevice/list",
    name: "imageDevice",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/cameraManagement/imageDevice/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "影像设备",
    }
  },
  {
    path: "/imageDevice/checkDevicedetails/baseInformation",
    name: "baseInformation",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/cameraManagement/imageDevice/checkDevicedetails/baseInformation.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "查看影像设备详情_基本信息",
    }
  },
  {
    path: "/imageDevice/checkDevicedetails/Preset",
    name: "Preset",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/cameraManagement/imageDevice/checkDevicedetails/Preset.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "查看影像设备详情_预置点",
    }
  },
  {
    path: "/imageDevice/checkDevicedetails/presetDetails",
    name: "presetDetails",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/cameraManagement/imageDevice/checkDevicedetails/presetDetails.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "预置点详情",
    }
  },
  {
    path: "/platformMessage/list",
    name: "platformMessage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/messageManagement/platformMessage/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "平台消息管理"
    }
  },
  {
    path: "/platformMessage/create",
    name: "Create",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/messageManagement/platformMessage/create.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "新建消息"
    }
  },
  {
    path: "/platformMessage/checkMessage/:id",
    name: "checkMessage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/messageManagement/platformMessage/checkMessage.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "查看消息"
    }
  },
  {
    path: "/ideaFeedback/list",
    name: "ideaFeedback",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/interactiveManagement/ideaFeedback/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "意见反馈"
    }
  },
  {
    path: "/ideaFeedback/checkFeedback/:id",
    name: "checkFeedback",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/interactiveManagement/ideaFeedback/checkFeedback.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "查看反馈"
    }
  },
  {
    path: "/submintFeedback/submint",
    name: "submint",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/about/submintFeedback/submint.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "提交反馈"
    }
  },
  {
    path: "/submintFeedback/feedbackSuccess",
    name: "feedbackSuccess",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/about/submintFeedback/feedbackSuccess.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "反馈成功"
    }
  },
  {
    path: "/connectionUs/connection",
    name: "connection",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/about/connectionUs/connection.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "联系我们"
    }
  },
  {
    path: "/order/list",
    name: "order",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/order/order/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "订单管理"
    }
  },
  {
    path: "/order/detail",
    name: "orderDetail",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/order/order/detail.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "订单详情"
    }
  },
  {
    path: "/platformExpenses/list",
    name: "platformExpenses",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/finance/platformExpenses/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "香油钱流水"
    }
  },
  {
    path: "/localExpenses/list",
    name: "localExpenses",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/finance/localExpenses/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "本地安灯收支情况"
    }
  },
  {
    path: "/onlineExpenses/list",
    name: "onlineExpenses",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/finance/onlineExpenses/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "线上安灯收支情况"
    }
  },
  {
    path: "/MessageCenter/list",
    name: "list",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/MessageCenter/list.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "消息中心"
    }
  },
  {
    path: "/MessageCenter/checkMessage/:id",
    name: "checkMessage",
    component: () =>
      import(
        /* webpackChunkName: "role-create" */
        "@/views/MessageCenter/checkMessage.vue"
      ),
    meta: {
      isShowHeader: true,
      isShowLeftSider: true,
      name: "查看消息"
    }
  },
  {
    path: "*", // 此处需特别注意至于最底部
    redirect: "/"
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js